const capture = {
  type: 'confirm',
  name: 'capture',
  message: 'Capture charge?',
}

export default {
  capture,
}
